import GlobalProvider from './contexts/Global'
import AuthProvider from './contexts/Auth'
import ThemeProvider from './contexts/Theme'
import LayoutProvider from './contexts/Layout'
import Router from './router'
import { Footer, NavBar } from './components'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useState, useEffect } from 'react'
import { eventDataLayer } from './commons/utils'
import { cspQuery } from './helpers'
import { Helmet } from 'react-helmet-async'
import { getApplicationTokenAPI } from './Api'
import Cookies from 'js-cookie'

function App() {
  const [cspConfig, setCspConfig] = useState('')
  const [isLoaded, setIsLoaded] = useState(false)
  const [csrfToken, setCsrfToken] = useState('')

  const csp = async (csrfToken) => {
    setIsLoaded(true)
    const configCsp = await cspQuery(csrfToken)
    if (configCsp.data.csp) {
      setCspConfig(configCsp.data.csp)
    }
  }

  const fetchData = () => {
    const getToken = async () => {
      if (!Cookies.get('access_tokens')) {
        var data = await getApplicationTokenAPI()
        Cookies.set('access_tokens', data.data)
      }
      return Cookies.get('access_tokens')
    }

    getToken()
      .then((data) => {
        if (data) {
          setCsrfToken(data)
          csp(data)
        }
      })
      .catch((err) => {
        //user already logged
        if (csrfToken) {
          csp(csrfToken)
        } else {
          csp(null)
        }
      })
  }

  useEffect(() => {
    if (window && window.dataLayer) {
      eventDataLayer({
        event: 'virtual_page_view',
        pageName: window.location.hostname,
        tipologia_fornitura: '',
        forniture_attive: '',
        crm_id: '',
        login_status: 'not_logged',
        mercato: '',
        modalita_login: '',
        area: 'area_clienti',
        stream: 'web',
        categoria: '',
        tipologia_utente: '',
        offerta: '',
        order_id: '',
        sezione: 'login',
        categoria_articolo: '',
        posizionamento_articolo: '',
        nome_articolo: '',
        pageType: 'login',
        vas: '',
      })
    }

    fetchData()
  }, [])

  return (
    isLoaded && (
      <BrowserRouter>
        <Helmet>
          <meta httpEquiv="Content-Security-Policy" content={cspConfig}></meta>
        </Helmet>
        <GlobalProvider>
          <AuthProvider csrfToken={csrfToken}>
            <ThemeProvider>
              <LayoutProvider>
                <NavBar />
                <Router />
                <ToastContainer
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar={true}
                  closeOnClick
                  theme="colored"
                  limit={1}
                  newestOnTop
                />
              </LayoutProvider>
            </ThemeProvider>
            <Footer />
          </AuthProvider>
        </GlobalProvider>
      </BrowserRouter>
    )
  )
}

export default App
